<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17hRqHB/tc-custom/9781398466821.jpg?1674925501533" alt="This image is the cover for the book Jamieson"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jamieson
      </h1>
      <p class="bookDescription body article font2">
        <p>WHAT WOULD YOU DO IF YOU WERE OFFERED THE CHANCE OF A NEW LIFE? I struggled with the decision – leave my home completely – running away from my family was the first step, the other side of the world couldn’t hurt? A CHANCE TO FINALLY BE YOURSELF. I could finally move out of the shadows and see what I could do. TO BE ACCEPTED FOR WHO, NOT WHAT YOU ARE. Ever since the wings had grown, all I was seen as was a monster. Maybe now they would be able to see past them, to who I really am. I supposeall I could do was wait and see.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lori Lee
      </h2>
      
      <p class="authorDescription body article">Growing up on a farm in rural Devon, Lori developed a passion for books at an early age, absorbing a range of genres from crime/horror to fantasy and more. She loves the idea of travelling to different worlds without having to leave her home and started to envisage characters in her head who were outside of the norm. When she isn't working full-time her hobbies also include woodworking, walking and acting in the local theatre group.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b43f9058